<template>
	<div class="inner">
        <div class="headline">
            <h1>{{$t('screening.create.headline')}}</h1>
            <p>{{getSingleProperty.address}}</p>
        </div>
        <div class="content-box small">
            <div class="container">
                <h2>{{$t('screenings.new.info.headline')}}</h2>
                <p>{{$t('screenings.new.info.text')}}</p>

                <div class="boxes three screening-info first">
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/nemid.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.nemid.headline')}}</h3>
                                <p>{{$t('screenings.new.nemid.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.nemid.label')}}</p>
                                <p>{{$t('screening-time.nemid.text')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/income.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.income.headline')}}</h3>
                                <p>{{$t('screenings.new.income.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.income.label')}}</p>
                                <p>{{$t('screening-time.income.text')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/economic.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.rki.headline')}}</h3>
                                <p>{{$t('screenings.new.rki.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.rki.label')}}</p>
                                <p>{{$t('screening-time.rki.text')}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="boxes three screening-info">
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/cpr.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.cpr.headline')}}</h3>
                                <p>{{$t('screenings.new.cpr.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.cpr.label')}}</p>
                                <p>{{$t('screening-time.cpr.text')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/work.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.employment.headline')}}</h3>
                                <p>{{$t('screenings.new.employment.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.work.label')}}</p>
                                <p>{{$t('screening-time.work.text')}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="content">
                            <div class="icon">
                                <img src="/images/img/screening/study.png">
                            </div>
                            <div>
                                <h3>{{$t('screenings.new.student.headline')}}</h3>
                                <p>{{$t('screenings.new.student.text')}}</p>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="clock">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 40 40">
                                  <path class="fill-grey" d="M2073,1319a20.007,20.007,0,0,1-9.52-37.6,2,2,0,1,1,1.91,3.52,15.991,15.991,0,1,0,9.61-1.8V1294h0v5a2.009,2.009,0,0,1-.66,1.48,0.085,0.085,0,0,1-.03.03l-5.8,5.8a1.994,1.994,0,0,1-2.82-2.82l5.31-5.32V1289h0v-8a2.006,2.006,0,0,1,2-2A20,20,0,0,1,2073,1319Z" transform="translate(-2053 -1279)"/>
                                </svg>
                            </div>
                            <div>
                                <p class="label">{{$t('screening-time.student.label')}}</p>
                                <p>{{$t('screening-time.student.text')}}</p>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="button-container middle">
		            <a onclick="window.history.go(-1); return false;" class="back">
		            	<simple-svg
			            	:filepath="'/images/SVG/Arrow.svg'"
		            		:width="'12.5px'"
		            		:height="'10px'"
		            	/>
		            	{{$t('button.goback')}}
		            </a>
		            <router-link disabled to="#" class="button purple">
		            	{{$t('button.continue')}}
		            </router-link>
		        </div>
            </div>

        </div>

    </div>
</template>
<script>
    import {store} from "../../store";
    import {mapGetters} from 'vuex';
    import createEntity from "../../mixins/create-entity";
	export default {
        mixins: [createEntity],
	    beforeRouteEnter(to, from, next){
            if(from.path !== '/screenings/select-property'){
                next('/screenings/select-property');
            }
            next();
        },
        data(){
            return {

                screeningInfo: [
                    {   col: 'income',
                        link: '/',
                        svgIcon: '/images/SVG/Screening/Income.svg',
                        title: 'Income',
                        text: 'See what the applicants disposable income is'
                    },
                    {   col: 'rki-status',
                        link: '/',
                        svgIcon: '/images/SVG/Screening/RKI.svg',
                        title: 'RKI Status',
                        text: 'See if the applicant is registered as a bad payer'
                    },
                    {   col: 'work',
                        link: '/',
                        svgIcon: '/images/SVG/Screening/Work.svg',
                        title: 'Work',
                        text: 'See if the applicant has a steady job & career'
                    },
                    {   col: 'education',
                        link: '/',
                        svgIcon: '/images/SVG/Screening/Education.svg',
                        title: 'Education',
                        text: 'See if the applicant is studying & for how long'
                    }
                ]
            }

        },
        methods: {

        },
        computed:{
            ...mapGetters([
                'getSingleProperty'
            ])
        }
    }
</script>
<style>
</style>
